import { InvoiceSuggestion } from "../../../models/InvoiceSuggestion";

export const getInvoiceSuggestion = (data: any): InvoiceSuggestion => {
  const a = data.attributes;
  return {
    id: data.id,
    orderId: a.order_id,
    dumpEventId: a.dump_event_id,
    suggestedDumped: Number(a.suggested_dumped),
    suggestedAllowed: Number(a.suggested_allowed),
    feePerPound: Number(a.fee_per_pound),
    status: a.status,
    orderName: a.order_name || "",
    orderAddress: a.order_address || "",
    orderDumpsterSize: a.order_dumpster_size || "",
    orderBasePrice: Number(a.order_base_price) || 0,
  };
};

export const getInvoiceSuggestions = (data: any): InvoiceSuggestion[] => {
  return data.map(getInvoiceSuggestion);
};
